import { Space } from "antd";
import styled from "styled-components";

const FlexSpace = styled(Space)`
  &.ant-space {
    display: flex;
    & > .ant-space-item {
      display: flex;
    }
  }
`;

export { FlexSpace };
